import { render, staticRenderFns } from "./SubCategoryRow.vue?vue&type=template&id=034f6125&scoped=true"
import script from "./SubCategoryRow.vue?vue&type=script&lang=js"
export * from "./SubCategoryRow.vue?vue&type=script&lang=js"
import style0 from "./SubCategoryRow.vue?vue&type=style&index=0&id=034f6125&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034f6125",
  null
  
)

export default component.exports